import { create } from 'zustand';

const useRequestStore = create((set) => ({
  data: {},
  addStepData: (stepData) =>
    set((state) => {
      const data = { ...state.data, ...stepData };
      return { data };
    }),
  clearData: () => set({ data: {} }),
}));

export default useRequestStore;
